<ng-container>
    @if (isOpen) {
        <app-order-login></app-order-login>
    }
    @if (authService.auth$ | async) {
        <app-billing-address-display
            [billingAddress]="billingAddress"
            [isOpen]="isOpen"
            (prev)="prev.emit($event)"
            (next)="next.emit($event)"
        ></app-billing-address-display>
    } @else {
        <app-billing-address-form
            [billingAddress]="billingAddress"
            [insurants]="insurants"
            [isOpen]="isOpen"
            (prev)="prev.emit($event)"
            (next)="next.emit($event)"
        ></app-billing-address-form>
    }
</ng-container>
